import script from "./SelectMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectMultiple.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__